/**
 * @generated SignedSource<<dc1808ecc709ea551f345c89f6ba343c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphCode_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphCode";
  readonly description: string;
  readonly id: string;
  readonly language: string | null;
  readonly lastModifiedDate: string | null;
  readonly matchedChunks: ReadonlyArray<{
    readonly id: string;
    readonly lineRange: {
      readonly start: number;
    };
    readonly matchedRanges: ReadonlyArray<ReadonlyArray<number>>;
    readonly sourceCode: string;
  }>;
  readonly path: string;
  readonly repository: {
    readonly name: string;
    readonly namespace: string;
    readonly scm: string | null;
    readonly url: string;
  };
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "searchGraphCode_AtlassianSearchPage";
};
export type searchGraphCode_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphCode_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphCode_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphCode_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "path"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "language"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "SearchResultCodeChunk",
      "kind": "LinkedField",
      "name": "matchedChunks",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "sourceCode"
        },
        {
          "concreteType": "SearchResultCodeLineRange",
          "kind": "LinkedField",
          "name": "lineRange",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "start"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "matchedRanges"
        }
      ]
    },
    {
      "concreteType": "SearchResultCodeRepository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "namespace"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "scm"
        }
      ]
    }
  ],
  "type": "SearchResultGraphCode"
};
})();

(node as any).hash = "a8a93407d0a098e6a727010d788b16b0";

export default node;
